/* eslint-disable semi */
import crypto from 'crypto'
const algorithm = 'aes-256-cfb';
const keyStr = '2oinakpeiy87ggla';
export default {
  encryptText (text) {
    const hash = crypto.createHash('sha256');
    hash.update(keyStr);
    const keyBytes = hash.digest();
    const iv = crypto.randomBytes(16);
    const cipher = crypto.createCipheriv(algorithm, keyBytes, iv);
    let enc = [iv, cipher.update(text, 'utf8')];
    enc.push(cipher.final());
    return Buffer.concat(enc).toString('base64');
  },
  decryptText (text) {
    const hash = crypto.createHash('sha256');
    hash.update(keyStr);
    const keyBytes = hash.digest();

    const contents = Buffer.from(text, 'base64');
    const iv = contents.slice(0, 16);
    const textBytes = contents.slice(16);
    const decipher = crypto.createDecipheriv(algorithm, keyBytes, iv);
    let res = decipher.update(textBytes, '', 'utf8');

    res += decipher.final('utf8');

    for(let i = res.length - 1; i >= 0 ; i--) {
      if( res[i] !== "\u0000") {
        res = res.substring(0, i + 1);
        break;
      }
    }

    return res;
  },

  /** 取得 HMAC_DRBG key */
  getAesKey (baseKey) {
    const hmac_drbg = crypto.createHmac('sha256', baseKey);
    return hmac_drbg.digest();
  },

  /** 加密 */
  encryptAesText (text) {
    const keyBytes = this.getAesKey(keyStr);
    const iv = crypto.randomBytes(16);
    const cipher = crypto.createCipheriv('aes-256-cfb', keyBytes, iv);
    let enc = [iv, cipher.update(text, 'utf8')];
    enc.push(cipher.final());
    return Buffer.concat(enc).toString('base64');
  },

  /** 解密 */
  decryptAesText (text) {
    const keyBytes = this.getAesKey(keyStr);
    const contents = Buffer.from(text, 'base64');
    const iv = contents.slice(0, 16);
    const textBytes = contents.slice(16);
    const decipher = crypto.createDecipheriv('aes-256-cfb', keyBytes, iv);
    let res = decipher.update(textBytes, '', 'utf8');
    res += decipher.final('utf8');
    return res;
  },

  encryptObject (object) {
    return this.encryptText(JSON.stringify(object));
  },
  decryptObjectText (text) {
    return JSON.parse(String(this.decryptText(text)));
  },
  objectToURIComponent (object) {
    let dataJson = JSON.stringify(object)
    let dataToken = this.encryptText(dataJson)
    return encodeURIComponent(dataToken)
  },
  uriComponentToObject (text) {
    let dataToken = decodeURIComponent(text)
    return JSON.parse(this.decryptText(dataToken))
  },


}
